import React, { Component } from 'react'
import Parser from 'html-react-parser'
import { ChevronDownIcon } from './SVGIcons'

class App extends Component {
  constructor(props) {
    super(props)
    this.state = {
      openIndex: 0 // по умолчанию открыт первый элемент (индекс 0)
    }
  }

  toggleAccordion = (index) => {
    this.setState(prevState => ({
      openIndex: prevState.openIndex === index ? -1 : index
    }))
  }

  render() {
    const data = this.props?.data || {}
    const cards = data?.faq || []

    const { openIndex } = this.state

    return (
      <div className='mt-[40px]'>
        <div className='container'>

          <div className='text-title text-ptblack uppercase tracking-tight leading-none'>{Parser(data?.h1 || data?.pagetitle)}</div>
          <div className='text-base text-ptgray max-w-[742px] leading-none mt-[10px]'>
            {Parser(data?.introtext || '')}
          </div>

          <div className='pt-[10px] mt-[40px]'>
            {cards.map((elm, index) => (
              <div 
                key={index}
                className='mt-[10px] bg-[#F6F7F8] rounded-[15px] p-[20px] cursor-pointer'
                onClick={() => this.toggleAccordion(index)}
              >
                <div className='flex items-center justify-between gap-[20px] text-[#032432] text-[16px] xl:text-cardTitle uppercase'>
                  <div>{elm.q}</div>
                  <div className={`w-[30px] h-[30px] xl:w-[38px] xl:h-[38px] flex-none rounded-[14px] flex items-center justify-center  transition-transform duration-300 ${
                    openIndex === index ? 'rotate-180 bg-white text-[#001553]' : 'bg-[#001553] text-white'
                  }`}>
                    <ChevronDownIcon width={12} height={6} stroke="currentColor" />
                  </div>
                </div>
                
                {/* Анимация для плавного появления/скрытия */}
                <div 
                  className={`overflow-hidden transition-all duration-300 ${
                    openIndex === index ? 'max-h-[500px] opacity-100 mt-[10px]' : 'max-h-0 opacity-0'
                  }`}
                >
                  <div className='text-[12px] xl:text-base text-black/60 tracking-[-0.02em] page_content'>
                    {Parser(elm.a)}
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className='text-title text-ptblack uppercase tracking-tight leading-none mt-[100px]'>как Ветер влияет <span className='text-ptgray'>на температуру</span></div>
          <div className='text-base text-ptgray max-w-[742px] leading-none mt-[10px]'>
            Кратко о ветро-холодовом индексе: почему при одинаковой температуре на улице может ощущаться заметно холоднее, и как это учитывать в зимней эксплуатации.
          </div>
          <div className='mt-[40px] flex flex-col md:flex-row justify-between gap-[20px] items-start leading-none'>
            <div className='flex-auto'>
              <div className='bg-[#F6F7F8] p-[20px] rounded-[14px] text-base text-ptgray w-full page_content'>
                <p>Для человека важна не столько температура «за бортом», сколько то, как он на нее будет реагировать. А реагирует он по-разному, потому что <span className="text-ptblack">на ощущение температуры сильно влияет ветер</span>. Может подуть так, что покажется будто бы в два раза холоднее, чем есть на самом деле. Есть у метеорологов понятие - <span className="text-ptblack">«ветро-холодовой индекс»</span>, который учитывает скорость ветра и <span className="text-ptblack">позволяет рассчитать «настоящую» температуру воздуха.</span></p>
                <p>Иными словами, <span className="text-ptblack">при скорости ветра в 13 метров в секунду</span> безобидные <span className="text-ptblack">-20 потянут почти на 50 градусов мороза.</span></p>
              </div>
              <div className='hidden md:block mt-[20px] bg-[#F6F7F8] p-[20px] rounded-[14px] text-base text-ptgray w-full page_content'>
                <p>Для приготовления <span className="text-ptblack">ОЖ с температурой кристаллизации – 40</span> концентрат необходимо разбавить дистиллированной водой в следующих объемных соотношениях:</p>
                <p>количество концентрата - <span className="text-ptblack">56%</span>, количество воды - <span className="text-ptblack">44%</span>.</p>
              </div>
              <div className='hidden md:block mt-[20px] bg-[#F6F7F8] rounded-[14px] overflow-hidden text-base text-ptgray w-full page_content'>
                <table>
                  <tbody>
                    <tr>
                      <th className='text-center bg-[#001553] text-base font-normal text-white py23px'>Температура замерзания, °С</th>
                      <th className='text-center bg-[#001553] text-base font-normal text-white py23px'>Количество концентрата, % объемные</th>
                      <th className='text-center bg-[#001553] text-base font-normal text-white py23px'>Количество воды, % объемные</th>
                    </tr>
                    <tr>
                      <td className='text-center text-base text-ptblack py39px'>-40 °С</td>
                      <td className='text-center text-base text-ptblack py39px'>56</td>
                      <td className='text-center text-base text-ptblack py39px'>44</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div className='flex-none w-full md:w-[414px] bg-[#F6F7F8] rounded-[14px] overflow-hidden page_content max-w-full overflow-x-auto'>
              <table>
                <tbody>
                  <tr>
                    <td> </td>
                    <th colSpan="3" className='text-center bg-[#001553] min-h-[60px] text-base font-normal text-white'>На градуснике, °C </th>
                  </tr>
                  <tr>
                    <td> </td>
                    <td className='text-center min-h-[93px] text-base text-ptblack'>-20</td>
                    <td className='text-center min-h-[93px] text-base text-ptblack'>-25</td>
                    <td className='text-center min-h-[93px] text-base text-ptblack'>-30</td>
                  </tr>
                  <tr>
                    <th className='text-center bg-[#001553] min-h-[60px] text-base font-normal text-white'>Скорость ветра, м/c</th>
                    <th colSpan="3" className='text-center bg-[#001553] min-h-[60px] text-base font-normal text-white'>Температура на самом деле,  °C</th>
                  </tr>
                  <tr>
                    <td className='text-center min-h-[93px] text-base text-ptblack'>3</td>
                    <td className='text-center min-h-[93px] text-base text-ptblack'>-23</td>
                    <td className='text-center min-h-[93px] text-base text-ptblack'>-28</td>
                    <td className='text-center min-h-[93px] text-base text-ptblack'>-33</td>
                  </tr>
                  <tr>
                    <td className='text-center min-h-[93px] text-base text-ptblack'>5</td>
                    <td className='text-center min-h-[93px] text-base text-ptblack'>-34</td>
                    <td className='text-center min-h-[93px] text-base text-ptblack'>-38</td>
                    <td className='text-center min-h-[93px] text-base text-ptblack'>-44</td>
                  </tr>
                  <tr>
                    <td className='text-center min-h-[93px] text-base text-ptblack'>7</td>
                    <td className='text-center min-h-[93px] text-base text-ptblack'>-39</td>
                    <td className='text-center min-h-[93px] text-base text-ptblack'>-44</td>
                    <td className='text-center min-h-[93px] text-base text-ptblack'>-51</td>
                  </tr>
                  <tr>
                    <td className='text-center min-h-[93px] text-base text-ptblack'>9</td>
                    <td className='text-center min-h-[93px] text-base text-ptblack'>-43</td>
                    <td className='text-center min-h-[93px] text-base text-ptblack'>-49</td>
                    <td className='text-center min-h-[93px] text-base text-ptblack'>-53</td>
                  </tr>
                  <tr>
                    <td className='text-center min-h-[93px] text-base text-ptblack'>11</td>
                    <td className='text-center min-h-[93px] text-base text-ptblack'>-46</td>
                    <td className='text-center min-h-[93px] text-base text-ptblack'>-42</td>
                    <td className='text-center min-h-[93px] text-base text-ptblack'>-60</td>
                  </tr>
                  <tr>
                    <td className='text-center min-h-[93px] text-base text-ptblack'>13</td>
                    <td className='text-center min-h-[93px] text-base text-ptblack'>-49</td>
                    <td className='text-center min-h-[93px] text-base text-ptblack'>-54</td>
                    <td className='text-center min-h-[93px] text-base text-ptblack'>-63</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className='md:hidden bg-[#F6F7F8] p-[20px] rounded-[14px] text-base text-ptgray w-full page_content'>
              <p>Для приготовления <span className="text-ptblack">ОЖ с температурой кристаллизации – 40</span> концентрат необходимо разбавить дистиллированной водой в следующих объемных соотношениях:</p>
              <p>количество концентрата - <span className="text-ptblack">56%</span>, количество воды - <span className="text-ptblack">44%</span>.</p>
            </div>
            <div className='md:hidden bg-[#F6F7F8] rounded-[14px] overflow-hidden text-base text-ptgray w-full page_content'>
              <table>
                <tbody>
                  <tr>
                    <th className='text-center bg-[#001553] text-base font-normal text-white py23px'>Температура замерзания, °С</th>
                    <th className='text-center bg-[#001553] text-base font-normal text-white py23px'>Количество концентрата, % объемные</th>
                    <th className='text-center bg-[#001553] text-base font-normal text-white py23px'>Количество воды, % объемные</th>
                  </tr>
                  <tr>
                    <td className='text-center text-base text-ptblack py39px'>-40 °С</td>
                    <td className='text-center text-base text-ptblack py39px'>56</td>
                    <td className='text-center text-base text-ptblack py39px'>44</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default App